import React from "react";
import { Button, Result as AntResult } from "antd";
import { useTranslation } from "react-i18next";
import styled from 'styled-components';

const Result = styled(AntResult)`
  .ant-result-title, .ant-result-subtitle {
    color: ${props => props.theme.textColor} !important;
  }
  .ant-btn-primary {
    background: ${props => props.theme.white} !important;
  }
`;

const Page500 = () => {
  const { t } = useTranslation();

  return (
    <Result
      status="500"
      title="Oops!"
      subTitle={t("error.subtitle500")}
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          {t("error.retry")}
        </Button>
      }
    />
  );
};

export default Page500;
